<template>
  <div class="solutions-cards" id="solutions-cards">
    <div class="sqheader p-2 m-1">
      <div class="heasub p-1 pl-4" v-if="tstructure != 'Untabbed'">
        {{ retyped_questions.subject }}
      </div>
      <div class="heasub p-1 pl-4" v-if="tstructure == 'Untabbed'">
        All Questions
      </div>
      <div class="sqicon">
        <b-icon-plus
          font-scale="2"
          v-if="showplus"
          @click="
            showplus = false;
            showquest = true;
            showminus = true;
          "
          class="sqbicon"
        ></b-icon-plus>

        <b-icon-dash
          font-scale="2"
          v-if="showminus"
          @click="
            showquest = false;
            showminus = false;
            showplus = true;
          "
          class="sqbicon"
        ></b-icon-dash>
      </div>
    </div>
    <div class="sqbody" v-if="showquest || downloadAll">
      <i-qwrapper
        class="esq m-2 p-3"
        v-for="(question, index) in retyped_questions.questions"
        :key="index"
        :sn="index + 1"
        :question="question"
        :qattempted="attempted"
      ></i-qwrapper>
    </div>
  </div>
</template>

<script>
import iQwrapper from "@/components/iQwrapper";
export default {
  components: {
    iQwrapper
  },
  props: ["questions", "attempted", "tstructure", "downloadAll"],
  data() {
    return {
      showplus: true,
      showminus: false,
      showquest: false,
      retyped_questions: {}
    };
  },
  created() {
    if (this.tstructure == "Untabbed") {
      this.retyped_questions = Object.create(Object.prototype, {
        questions: { value: this.questions }
      });
    } else {
      this.retyped_questions = this.questions;
    }
  },
  watch: {
    async downloadAll() {
      if (this.downloadAll) {
        await this.$nextTick(() => {
          this.printElement();
        });

        this.$forceUpdate();
      }
    }
  },
  computed: {
    downloadingAll() {
      return this.downloadAll ? true : false;
    }
  },
  methods: {
    printElement() {
      var $printSection = document.getElementById("solutions-cards");
      var currentBody = document.body.innerHTML;

      document.body.innerHTML = $printSection.innerHTML;

      window.print();

      document.body.innerHTML = currentBody;
    }
  }
};
</script>

<style scoped>
.fhe {
  background-color: blue;
  color: white;
  border-radius: 20px 20px 0px 0px;
  font-weight: bold;
}

.detailsflex {
  display: flex;
}

.detailslabel {
  width: 35%;
  font-size: 1.1rem;
}

.detailsvalue {
  width: 65%;
  font-size: 1.2rem;
  font-weight: bolder;
}

.sqheader {
  font-size: 1.2rem;
  background-color: rgba(255, 255, 255, 0.96);
  border: 1px solid rgb(247, 244, 244);
  border-radius: 10px 10px;
  display: flex;
  font-weight: bold;
}

.heasub {
  width: 70%;
}

.sqicon {
  width: 30%;
  text-align: right;
  cursor: pointer;
}

.esq {
  border-radius: 10px 10px;
}

.form-rad {
}
</style>
